import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Facebook from '../Facebook';
import Twitter from '../Twitter';
// import ogImg from '../../../../public/images/og-img.png';

const icon32Path = '/images/icon_32.png';

const getSiteUrl = (language) => {
  switch (language) {
    case 'en':
      return 'https://www.lingualbox.com';
    case 'ja':
      return 'https://ja.lingualbox.com';
    case 'es':
      return 'https://es.lingualbox.com';
    case 'pt':
      return 'https://pt.lingualbox.com';
    case 'tw':
      return 'https://tw.lingualbox.com';
    case 'ru':
      return 'https://ru.lingualbox.com';
    default:
      return 'https://www.lingualbox.com';
  }
};

const getOgLanguage = (language) => {
  switch (language) {
    case 'en':
      return 'en_US';
    case 'ja':
      return 'ja_JP';
    case 'es':
      return 'es_ES';
    case 'pt':
      return 'pt_BR';
    case 'tw':
      return 'zh_TW';
    case 'ru':
      return 'ru_RU';
    default:
      return 'en_US';
  }
};

type Props = {
  title?: string;
  desc?: string;
  banner?: string;
  pathname?: string;
  article?: boolean;
  imageUrl?: string;
};

const SEO = (props: Props) => {
  const router = useRouter();
  const { locale, asPath: path } = router;
  const { t } = useTranslation('common');
  const { title, imageUrl, desc } = props;
  // const author = 'LingualBox, Inc.'
  const defaultTitle = t('title.default');
  const defaultDescription = t('description.default');
  // const headline = t('headline')
  const siteUrl = getSiteUrl(locale);
  const ogLanguage = getOgLanguage(locale);
  const defaultBanner = '/public/images/og-img.png';
  let imgUrl = imageUrl;
  if (typeof imageUrl === 'undefined') {
    imgUrl = `${siteUrl}${defaultBanner}`;
  }

  const seo = {
    title: title || defaultTitle,
    // headline,
    description: desc || defaultDescription,
    image: imgUrl,
    url: `${siteUrl}${path || ''}`,
    icon32Url: `${siteUrl}${icon32Path}`,
  };

  return (
    <>
      <Head>
        <meta
          key="meta-viewport"
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <meta
          key="meta-compatible"
          httpEquiv="X-UA-Compatible"
          content="IE=edge"
        />
        <meta
          key="content-type-text"
          httpEquiv="Content-Type"
          content="text/html; charset=utf-8"
        />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <link rel="canonical" href={seo.url} />
        <meta key="meta-image" name="image" content={seo.image} />
      </Head>
      <Facebook
        desc={seo.description}
        image={seo.image}
        title={seo.title}
        type="website"
        url={seo.url}
        locale={ogLanguage}
      />
      <Twitter title={seo.title} image={seo.image} desc={seo.description} />
    </>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default SEO;
